export enum DocumentStatusEnum {
  New = 1,
  InReview = 2,
  Approved = 3,
  Archived = 4,
  Expired = 5,
  Declined = 6
}
